export const siteSettings = {
  name: "Equibit",
  link: "https://equibit.net",
  email: "support@equibit.net",
  appLink: "https://app.equibit.net",
};
